module.exports = __webpack_public_path__ + "img/saum_tieforange_ral2011.067c18cc.jpg";